import generateScale from "../../utils/generateScale";
const colors = {
    transparent: "transparent",
    current: "currentColor",
    brand: {
        DEFAULT: "#001BB8",
    },
    link: {
        DEFAULT: "#179EEE",
    },
    accessory: {
        "1": "#E54D2E",
        "2": "#6E56CF",
        "3": "#D6409F",
        "4": "#BDEE63",
        "5": "#179EEE",
        teal: { ...generateScale("teal"), DEFAULT: "var(--teal-9)" }, // #0090FF
        orange: { ...generateScale("orange"), DEFAULT: "var(--orange-9)" }, // #FF7F00
        purple: { ...generateScale("purple"), DEFAULT: "var(--purple-9)" }, // #6E56CF
        tomato: { ...generateScale("tomato"), DEFAULT: "var(--tomato-9)" }, // #E54D2E
        lime: { ...generateScale("lime"), DEFAULT: "var(--lime-9)" }, // #BDEE63
        sky: { ...generateScale("sky"), DEFAULT: "var(--sky-9)" }, // #7CE2FE
        gold: { ...generateScale("gold"), DEFAULT: "var(--gold-9)" }, // #978365
        pink: { ...generateScale("pink"), DEFAULT: "var(--pink-9)" }, // #D6409F
        green: { ...generateScale("green"), DEFAULT: "var(--green-9)" }, // #30A46C
        blue: { ...generateScale("blue"), DEFAULT: "var(--blue-9)" }, // #0090FF
        indigo: { ...generateScale("indigo"), DEFAULT: "var(--indigo-9)" }, // #3E63DD
        brown: { ...generateScale("brown"), DEFAULT: "var(--brown-9)" }, // #AD7F58
    },
    primary: {
        dark: "var(--primary-10)",
        hover: "var(--primary-11)",
        DEFAULT: "var(--primary-9)",
        light: "var(--primary-4)",
        lightness: "var(--primary-2)",
        ...generateScale("primary"),
    },
    secondary: {
        dark: "#5D7186", // gray-10
        DEFAULT: "#9DA9B6", // gray-12
        light: "#DDE5ED", // gray-4
        lightness: "#F4F7F9", // gray-3
    },
    gray: {
        black: "var(--gray-12)",
        dark: "var(--gray-10)",
        DEFAULT: "var(--gray-9)",
        light: "var(--gray-4)",
        lightest: "var(--gray-3)",
        lightness: "var(--gray-2)",
        ...generateScale("gray"),
    },
    success: {
        dark: "var(--teal-11)",
        DEFAULT: "var(--teal-9)",
        light: "var(--teal-4)",
        lightness: "var(--teal-2)",
        ...generateScale("teal"),
    },
    danger: {
        dark: "var(--red-11)",
        DEFAULT: "var(--red-9)",
        light: "var(--red-4)",
        lightness: "var(--red-2)",
        ...generateScale("red"),
    },
    warning: {
        dark: "var(--orange-11)",
        DEFAULT: "var(--orange-9)",
        light: "var(--orange-4)",
        lightness: "var(--orange-2)",
        ...generateScale("orange"),
    },
    attention: {
        DEFAULT: "var(--yellow-9)",
        ...generateScale("yellow"),
    },
    black: {
        DEFAULT: "#000000",
        a1: "rgba(0, 0, 0, 0.05)",
        a2: "rgba(0, 0, 0, 0.1)",
        a3: "rgba(0, 0, 0, 0.15)",
        a4: "rgba(0, 0, 0, 0.2)",
        a5: "rgba(0, 0, 0, 0.3)",
        a6: "rgba(0, 0, 0, 0.4)",
        a7: "rgba(0, 0, 0, 0.5)",
        a8: "rgba(0, 0, 0, 0.6)",
        a9: "rgba(0, 0, 0, 0.7)",
        a10: "rgba(0, 0, 0, 0.8)",
        a11: "rgba(0, 0, 0, 0.9)",
        a12: "rgba(0, 0, 0, 0.95)",
    },
    white: {
        DEFAULT: "#FFFFFF",
        a1: "rgba(255, 255, 255, 0.05)",
        a2: "rgba(255, 255, 255, 0.1)",
        a3: "rgba(255, 255, 255, 0.15)",
        a4: "rgba(255, 255, 255, 0.2)",
        a5: "rgba(255, 255, 255, 0.3)",
        a6: "rgba(255, 255, 255, 0.4)",
        a7: "rgba(255, 255, 255, 0.5)",
        a8: "rgba(255, 255, 255, 0.6)",
        a9: "rgba(255, 255, 255, 0.7)",
        a10: "rgba(255, 255, 255, 0.8)",
        a11: "rgba(255, 255, 255, 0.9)",
        a12: "rgba(255, 255, 255, 0.95)",
    },
};
export default colors;
